import { PlaylistAddCheck } from "@mui/icons-material";
import { FC } from "react";

import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { RidesSelectAllIconButton } from "./elements.styled";

interface IRidesSelectAllMobileIconProps {
  ariaLabel: string;
  onClick: () => void;
}

/** Compact hint next to the select-all checkbox (list rows + checkmark). */
export const RidesSelectAllMobileIcon: FC<IRidesSelectAllMobileIconProps> = ({
  ariaLabel,
  onClick,
}) => {
  return (
    // FramerTooltip shows "Select all" on hover (desktop); on mobile it renders children only.
    <FramerTooltip content={ariaLabel} mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}>
      <RidesSelectAllIconButton aria-label={ariaLabel} onClick={onClick}>
        <PlaylistAddCheck className="select-all-icon" fontSize="inherit" />
      </RidesSelectAllIconButton>
    </FramerTooltip>
  );
};
